import React, { useState, useContext } from "react";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Colors from "../../../Helper/Colors";
import {
  setUnreadMessages,
  setTicketData,
  setTicketStatus,
} from "../../../Redux/Actions/TechAppAction";
import { techappContext } from "../../../Api/techappReq";
import { Anchorme } from "react-anchorme";
import lang from "../lang/lang.json";

const NewMessage = ({ message, id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const { ticketComments } = useContext(techappContext);

  const unreadMessages = useSelector(
    (state) => state.TechAppReducer.unreadMessages,
  );

  return (
    <Modal closable={false} footer={null} key={id} open={visible}>
      <div
        style={{
          width: "300px",
          height: "400px",
          display: "flex",
          flexDirection: "column",
          borderRadius: 7,
          padding: "20px 0px",
        }}
      >
        {/* title */}
        <div
          style={{
            alignItems: "center",
            color: Colors.success,
            fontSize: 16,
            textAlign: "center",
          }}
        >
          {message?.title}
        </div>
        {/* body */}
        <div
          style={{
            width: "100%",
            maxHeight: "270px",
            overflow: "auto",
            direction: "rtl",
            margin: "10px 0",
            marginBottom: "auto",
          }}
          className="mv-remove-scroll"
        >
          <span
            style={{
              fontSize: 16,
              paddingHorizontal: 10,
              textAlign: "left",
              direction: "rtl",
            }}
          >
            <Anchorme style={{ textDecoration: "underline" }} target="blank">
              {message?.message ? message.message : message.full_body}
            </Anchorme>
          </span>
        </div>
        {/* action */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "auto",
          }}
        >
          <Button
            style={{
              width: "100%",
              height: 40,
              borderRadius: 30,
              justifyContent: "center",
              alignItems: "center",
              borderWidth: 1,
              borderColor: "rgb(210,210,210)",
              backgroundColor: Colors.royalBlue,
              opacity: 1,
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => {
              setVisible(false);
              navigate("/techapp/view-ticket");
              if (message.type?.id === "private") {
                dispatch(setTicketStatus(1));
              } else if (message.type?.id === "public") {
                dispatch(setTicketStatus(2));
              } else if (message.type?.id === "training") {
                dispatch(setTicketStatus(3));
              } else {
                dispatch(setTicketStatus(0));
              }
              dispatch(setTicketData(message));
              dispatch(
                setUnreadMessages(
                  unreadMessages.filter((al) => al.id !== message.id),
                ),
              );
              if (message.category_id) {
                ticketComments(message.id);
              }
            }}
          >
            {lang.VIEW_DETAILS}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NewMessage;
